/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Amenity } from './Amenity';
import {
    AmenityFromJSON,
    AmenityFromJSONTyped,
    AmenityToJSON,
    AmenityToJSONTyped,
} from './Amenity';
import type { Pricing } from './Pricing';
import {
    PricingFromJSON,
    PricingFromJSONTyped,
    PricingToJSON,
    PricingToJSONTyped,
} from './Pricing';

/**
 * 
 * @export
 * @interface CabinCategory
 */
export interface CabinCategory {
    /**
     * The category code
     * @type {string}
     * @memberof CabinCategory
     */
    code?: string;
    /**
     * The name of the category
     * @type {string}
     * @memberof CabinCategory
     */
    name?: string;
    /**
     * The name of the main category
     * @type {string}
     * @memberof CabinCategory
     */
    mainCategoryName?: string;
    /**
     * The code of the main category
     * @type {string}
     * @memberof CabinCategory
     */
    mainCategoryCode?: string;
    /**
     * Label of the cabin category
     * @type {string}
     * @memberof CabinCategory
     */
    label?: string;
    /**
     * The pricings of the category
     * @type {Array<Pricing>}
     * @memberof CabinCategory
     */
    pricings?: Array<Pricing>;
    /**
     * List of available amenities
     * @type {Array<Amenity>}
     * @memberof CabinCategory
     */
    amenities?: Array<Amenity>;
    /**
     * URL leading to the image of the cabin category
     * @type {string}
     * @memberof CabinCategory
     */
    imageUrl?: string;
    /**
     * URL leading to the preview image of the cabin category
     * @type {string}
     * @memberof CabinCategory
     */
    previewImageUrl?: string;
    /**
     * Indicator if cabin category is bookable
     * @type {boolean}
     * @memberof CabinCategory
     */
    available?: boolean;
}

/**
 * Check if a given object implements the CabinCategory interface.
 */
export function instanceOfCabinCategory(value: object): value is CabinCategory {
    return true;
}

export function CabinCategoryFromJSON(json: any): CabinCategory {
    return CabinCategoryFromJSONTyped(json, false);
}

export function CabinCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'mainCategoryName': json['mainCategoryName'] == null ? undefined : json['mainCategoryName'],
        'mainCategoryCode': json['mainCategoryCode'] == null ? undefined : json['mainCategoryCode'],
        'label': json['label'] == null ? undefined : json['label'],
        'pricings': json['pricings'] == null ? undefined : ((json['pricings'] as Array<any>).map(PricingFromJSON)),
        'amenities': json['amenities'] == null ? undefined : ((json['amenities'] as Array<any>).map(AmenityFromJSON)),
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'previewImageUrl': json['previewImageUrl'] == null ? undefined : json['previewImageUrl'],
        'available': json['available'] == null ? undefined : json['available'],
    };
}

export function CabinCategoryToJSON(json: any): CabinCategory {
    return CabinCategoryToJSONTyped(json, false);
}

export function CabinCategoryToJSONTyped(value?: CabinCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'mainCategoryName': value['mainCategoryName'],
        'mainCategoryCode': value['mainCategoryCode'],
        'label': value['label'],
        'pricings': value['pricings'] == null ? undefined : ((value['pricings'] as Array<any>).map(PricingToJSON)),
        'amenities': value['amenities'] == null ? undefined : ((value['amenities'] as Array<any>).map(AmenityToJSON)),
        'imageUrl': value['imageUrl'],
        'previewImageUrl': value['previewImageUrl'],
        'available': value['available'],
    };
}

